// Contact Form 7 ファイルアップロード：「選択されていません」をファイル名に置き換え
// HTML: <div> → <label class="file-label">...<input></label> + <p class="file-message">選択されていません</p>
document.addEventListener('DOMContentLoaded', function() {
  var noFileText = '選択されていません';
  for (var i = 1; i <= 6; i++) {
    var fileInput = document.getElementById('file_attachment' + i);
    if (!fileInput) continue;
    var label = fileInput.closest('.file-label');
    if (!label) continue;
    var box = label.parentNode;
    var messageEl = box ? box.querySelector('.file-message') : null;
    if (!messageEl) continue;
    fileInput.addEventListener('change', function(e) {
      var input = e.target;
      var lbl = input.closest('.file-label');
      var msg = lbl && lbl.parentNode ? lbl.parentNode.querySelector('.file-message') : null;
      if (!msg) return;
      var file = input.files[0];
      var display = file
        ? (file.name.length > 30 ? file.name.substring(0, 30) + '...' : file.name)
        : noFileText;
      msg.textContent = display;
    });
  }
});
